import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemUserInterfaceDashboardEditRoute: InvariantJiraRoute = {
	name: 'global-settings-system-ui-dashboard-edit',
	path: '/secure/admin/jira/EditApplicationProperties!default.jspa',
};
